import React from 'react'
import { FormattedMessage } from 'react-intl'
import Intro from 'src/Components/Intro'

const HomeownerIntro = props => (
  <Intro {...props}>
    <FormattedMessage
      id='HOIntro.salutation.message'
      defaultMessage='Here’s your current home report and tips on how to save money. Call or email with questions!'
    />
  </Intro>
)

export default HomeownerIntro
